import { AxiosResponse } from 'axios';
import { BUSINESS_PYTHON } from 'services/axios';
import { config } from 'config/config.local';
import {
  AssignVoucherPayload,
  AssignVoucherResponse,
  AssignableUsersResponse,
  VoucherSummary,
} from './types';

export const fetchVoucherSummary = (payload: {
  account_id: string;
}): Promise<AxiosResponse<VoucherSummary>> =>
  BUSINESS_PYTHON.post(`${config.routes.certifications.voucherSummary}`, payload);

export const fetchAssignableUsers = (
  url: string
): Promise<AxiosResponse<AssignableUsersResponse>> => {
  return BUSINESS_PYTHON.get(url);
};

// Deliberately has no client timeout. Aborting this POST does not roll back a commit the server
// already made, so a slow-but-successful assignment would be reported as failed and the UI would
// invite a resubmit under a fresh idempotency key — a real double-assignment.
export const assignVouchers = (
  url: string,
  payload: Omit<AssignVoucherPayload, 'account_id'>,
  idempotencyKey: string
): Promise<AxiosResponse<AssignVoucherResponse>> => {
  return BUSINESS_PYTHON.post(url, payload, {
    headers: {
      'Idempotency-Key': idempotencyKey,
    },
  });
};
